import colors from 'vuetify/lib/util/colors'

const hexToRgba = (hex, a) => {
    if (hex.slice(0, 1) == "#") hex = hex.slice(1);
  
    const r = parseInt("0x" + hex.slice(0, 2));
    const g = parseInt("0x" + hex.slice(2, 4));
    const b = parseInt("0x" + hex.slice(4, 6));
  
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};

const colorList = [
    colors.orange.base,
    colors.yellow.base,
    colors.lightGreen.base,
    colors.teal.base,
    colors.blue.base,
    colors.deepPurple.base,
    colors.pink.base,
    colors.red.base,
    colors.brown.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    colors.grey.base,
    // ...
]
const bgColorList = [
    hexToRgba(colors.orange.lighten4, 0.8),
    hexToRgba(colors.yellow.lighten4, 0.8),
    hexToRgba(colors.lightGreen.lighten4, 0.8),
    hexToRgba(colors.teal.lighten4, 0.8),
    hexToRgba(colors.blue.lighten4, 0.8),
    hexToRgba(colors.deepPurple.lighten4, 0.8),
    hexToRgba(colors.pink.lighten4, 0.8),
    hexToRgba(colors.red.lighten4, 0.8),
    hexToRgba(colors.brown.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    hexToRgba(colors.grey.lighten4, 0.8),
    // ...
]

const colorListIdMap = function (ids, colorList) {
    let tmpColorList = {};
    ids.forEach((id, index) => {
        tmpColorList[id] = colorList[index]
    })
    return tmpColorList;
}

export { colorList, bgColorList, colorListIdMap };